import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";
import EditPlanView from "./index.vue";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  computed: {
    planName() {
      const { applicationPlan } = this.$store.state.pages.plan;
      if (!applicationPlan) {
        return "";
      }
      return applicationPlan.name as string;
    },
    errorMessage() {
      const { editPlanView } = this.$store.state.pages.plan;
      if (!editPlanView) {
        return "";
      }
      return editPlanView.error as string;
    }
  },
  methods: {
    handleChange(event) {
      if (event.planName !== "") {
        this.$store.commit("pages/plan/updateEditPlanView", {
          error: ""
        });
      }
      this.$emit("change", event);
    },
    handlePressKey() {
      const isInvalidPlanName = this.planName.trim() === "";
      if (isInvalidPlanName) {
        return;
      }
      this.$store.commit("pages/plan/updateEditPlanViewVisible", {
        isVisible: false
      });
    }
  },
  render(createElement) {
    return createElement(EditPlanView, {
      props: {
        planName: this.planName,
        errorMessage: this.errorMessage
      },
      on: {
        change: this.handleChange,
        pressKey: this.handlePressKey
      }
    });
  }
});
